import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { assetPathFnState } from '../../recoil/atoms';
import { sizeImage } from '../../util';
import styles from './Spinner.module.scss';

interface Props {
  visible: boolean;
  light?: boolean;
  forButton?: boolean;
  styleOverrides?: {
    spinner?: React.CSSProperties;
    img?: React.CSSProperties;
  };
}

export const Spinner: React.FC<Props> = ({ visible, light, forButton, styleOverrides }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);

  useEffect(() => {
    const image = new Image();
    image.src = assetPathFn('spinner-round_64x64.png');
  }, []);

  return visible ? (
    <span
      className={classNames(styles.hlSpinner, { [styles.hlLight]: light, [styles.forButton]: forButton })}
      style={{
        ...styleOverrides?.spinner,
        backgroundImage: `url("${sizeImage(assetPathFn('honeylove-icon-logo-coral.png'), '64x64')}")`,
        backgroundRepeat: 'no-repeat',
      }}
    >
      <img alt="loading" src={assetPathFn('spinner-round_64x64.png')} style={{ ...styleOverrides?.img }} />
    </span>
  ) : (
    <React.Fragment />
  );
};

export default Spinner;
